import React, { useState } from 'react'
import { Button, Hidden, Paper, TablePagination } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { routes } from 'Routes'
import { reverse } from 'named-urls'

import {
  Card,
  LoadingFeedback,
  MenuButton,
  Permitted,
  ConfirmationDialog,
} from 'components'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/Table'

import useFetch from 'hooks/useFetch'
import usePagination from 'hooks/usePagination'
import useSnackbar from 'hooks/useSnackbar'

import * as service from 'service'
import helpers from 'helpers'
import constants from 'constants/index'

const CycleTable = ({ pdcaId, isDisbled }) => {
  const snackbar = useSnackbar()
  const history = useHistory()
  const [openDestroyed, setDestroyed] = useState({
    open: false,
    pdcaCycleId: null,
  })
  const [loading, setLoading] = useState(false)

  const { perPage, page, handleChangePage, handleChangeRowsPerPage } =
    usePagination(10)

  const { response, isLoading, refresh } = useFetch(
    service.dponet.pdca.listCycles,
    { pdcaId, perPage, page },
    [pdcaId, perPage, page],
  )

  const { date } = helpers.formatters

  const cycles = response?.data?.monitoringManagementPdcaCycles || []
  const totalCount = response?.data?.meta?.totalCount || 0

  const handleCreate = () =>
    history.push(reverse(routes.pdca.newCycle, { pdcaId }))

  const handleEdit = (pdcaCycleId) =>
    history.push(reverse(routes.pdca.editCycle, { pdcaId, pdcaCycleId }))

  const handleShow = (pdcaCycleId) =>
    history.push(reverse(routes.pdca.showCycle, { pdcaId, pdcaCycleId }))
  const handleOpenDestroyed = (pdcaCycleId) =>
    setDestroyed({
      open: true,
      pdcaCycleId,
    })
  const handleCloseModal = () =>
    setDestroyed({
      open: false,
      pdcaCycleId: null,
    })

  const handleDelete = async () => {
    setLoading(true)
    try {
      await service.dponet.pdca.destroyCycles({
        pdcaId,
        pdcaCycleId: openDestroyed?.pdcaCycleId,
      })
      refresh()
      snackbar.open({
        message: 'Ciclo de PDCA excluído com sucesso.',
        variant: 'success',
      })
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error, false) ||
          'Falha na exclusão do ciclo de PDCA',
        variant: 'error',
      })
    } finally {
      setLoading(false)
      handleCloseModal()
    }
  }

  return (
    <>
      <Card
        title="Ciclo"
        actionButton={
          <Permitted
            tag={constants.permissions.MONITORING_MANAGEMENT_PDCA.MANAGE}
          >
            {!isDisbled && (
              <Button
                variant="contained"
                color="secondary"
                onClick={handleCreate}
              >
                Adicionar ciclo
              </Button>
            )}
          </Permitted>
        }
      >
        <LoadingFeedback open={isLoading || loading} />
        <Paper variant="outlined">
          <Table emptyMessage="Nenhum ciclo foi encontrado.">
            <TableHead>
              <TableRow>
                <TableCell width="5%">ID</TableCell>
                <TableCell width="15%">Quando?</TableCell>
                <TableCell width="30%">O que?</TableCell>
                <TableCell width="20%">Quem?</TableCell>
                <TableCell width="12%">Data prevista</TableCell>
                <TableCell width="12%">Data finalizado</TableCell>
                <TableCell align="center" width="6%">
                  Ações
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {cycles.map((cycle) => (
                <TableRow key={cycle?.id}>
                  <TableCell>#{cycle?.id}</TableCell>
                  <TableCell>{cycle?.planWhen || '-'}</TableCell>
                  <TableCell>{cycle?.planWhat || '-'}</TableCell>
                  <TableCell>{cycle?.planWho || '-'}</TableCell>
                  <TableCell align="center">
                    {date(cycle?.decisionExpectedDate)}
                  </TableCell>
                  <TableCell align="center">
                    {date(cycle?.decisionFinishedDate)}
                  </TableCell>
                  <TableCell align="center" size="small">
                    <MenuButton>
                      <Permitted
                        tag={
                          constants.permissions.MONITORING_MANAGEMENT_PDCA
                            .MANAGE
                        }
                      >
                        <Button
                          color="secondary"
                          fullWidth
                          size="small"
                          onClick={() => handleShow(cycle?.id)}
                        >
                          Visualizar
                        </Button>
                        {!isDisbled && (
                          <>
                            <Button
                              color="secondary"
                              fullWidth
                              size="small"
                              onClick={() => handleEdit(cycle?.id)}
                            >
                              Editar
                            </Button>
                            <Button
                              color="secondary"
                              fullWidth
                              size="small"
                              onClick={() => handleOpenDestroyed(cycle?.id)}
                            >
                              Excluir
                            </Button>
                          </>
                        )}
                      </Permitted>
                    </MenuButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <TablePagination
            component="div"
            count={totalCount}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            page={page - 1}
            rowsPerPage={perPage}
            rowsPerPageOptions={[5, 10, 15, 20]}
            labelRowsPerPage={<Hidden smDown>Por página</Hidden>}
            nextIconButtonProps={{ size: 'small' }}
            backIconButtonProps={{ size: 'small' }}
          />
        </Paper>
      </Card>
      {openDestroyed?.open && (
        <ConfirmationDialog
          open={openDestroyed?.open}
          setOpen={handleCloseModal}
          textButton="Confirmar"
          actionAcceptButton={handleDelete}
          text="Tem certeza que deseja excluir este ciclo de PDCA? Essa ação não pode ser desfeita."
          loading={loading}
        />
      )}
    </>
  )
}

export default CycleTable
